import React, { useState } from 'react';
import axiosInstance from '../request';
import { URL } from '../api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddLender = () => {
  const [lender, setLender] = useState({
    lender_name: '',
    email: '',
    contact_number: '',
    address: '',
    push_to_partner: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLender((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axiosInstance.post(URL.ADD_LENDER, lender);
      toast.success('Lender created successfully');

      setLender({
        lender_name: '',
        email: '',
        contact_number: '',
        address: '',
        push_to_partner: false,
      });
    } catch (err) {
      console.error('Create failed:', err);
      toast.error('Failed to create lender');
    }
  };

  return (
    <>
      <ToastContainer />
      <form onSubmit={handleSubmit} className="card shadow-sm">
        <div className="card-header bg-dark text-white">Add New Lender</div>
        <div className="card-body row g-3">

          <div className="col-md-6">
            <label><strong>Lender Name</strong></label>
            <input
              type="text"
              name="lender_name"
              value={lender.lender_name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="col-md-6">
            <label><strong>Email</strong></label>
            <input
              type="email"
              name="email"
              value={lender.email}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="col-md-6">
            <label><strong>Contact Number</strong></label>
            <input
              type="text"
              name="contact_number"
              value={lender.contact_number}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="col-md-6 d-flex align-items-end">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                name="push_to_partner"
                checked={lender.push_to_partner}
                onChange={handleChange}
                id="pushToPartner"
              />
              <label className="form-check-label" htmlFor="pushToPartner">
                <strong>Push to Partner</strong>
              </label>
            </div>
          </div>

          <div className="col-md-12">
            <label><strong>Address</strong></label>
            <textarea
              name="address"
              value={lender.address}
              onChange={handleChange}
              className="form-control"
              rows="2"
              required
            />
          </div>

          <div className="col-12 mt-3">
            <button type="submit" className="btn btn-success w-100">
              Add Lender
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddLender;
